import React, { useState, useEffect, useRef } from 'react';
import './safepage2.css';
import Settings from '../components/common/settings';

import { useNavigate } from 'react-router-dom';
import settingsSound from '../audios/settoings.wav';
import Lost from './../components/common/lost';

const TOTAL_TIME = 10 * 60;
const SECRET_CODE = '405';

const getInitialTime = () => {
  const saved = localStorage.getItem('room1_time');
  if (!saved) {
    localStorage.setItem('room1_time', Date.now());
    return TOTAL_TIME;
  }
  const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
  return Math.max(TOTAL_TIME - elapsed, 0);
};

const Safepage2 = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(getInitialTime);
  const [openSettings, setOpenSettings] = useState(false);
  const [input, setInput] = useState('');
  const [safeState, setSafeState] = useState('idle');
  const [dialSpin, setDialSpin] = useState(false);
  const [showLosePopup, setShowLosePopup] = useState(false);

  const settingsAudio = useRef(null);
  const wrongTimer = useRef(null);

  useEffect(() => {
    settingsAudio.current = new Audio(settingsSound);
  }, []);

  // TIMER (SHARED ROOM 1 TIMER)
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(() => {
        const saved = localStorage.getItem('room1_time');
        if (!saved) return TOTAL_TIME;

        const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
        const remaining = Math.max(TOTAL_TIME - elapsed, 0);

        if (remaining === 0) {
          setShowLosePopup(true);
          clearInterval(interval);
        }

        return remaining;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;
    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const handleDigit = (d) => {
    if (safeState === 'unlocked') return;
    if (input.length >= SECRET_CODE.length) return;

    setDialSpin(true);
    setTimeout(() => setDialSpin(false), 380);

    const next = input + d;
    setInput(next);

    if (next.length === SECRET_CODE.length) {
      if (next === SECRET_CODE) {
        setSafeState('unlocked');
      } else {
        setSafeState('wrong');
        clearTimeout(wrongTimer.current);

        wrongTimer.current = setTimeout(() => {
          setSafeState('idle');
          setInput('');
        }, 1000);
      }
    }
  };

  const handleClear = () => {
    if (safeState === 'unlocked') return;
    setInput('');
    setSafeState('idle');
  };

  const slots = Array.from({ length: SECRET_CODE.length }, (_, i) => {
    const ch = input[i] ?? '–';
    let cls = 'safe-digit';
    if (safeState === 'wrong') cls += ' wrong-digit';
    if (safeState === 'unlocked') cls += ' correct-digit';
    return <span key={i} className={cls}>{ch}</span>;
  });

  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');
  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

  const statusText =
    safeState === 'unlocked' ? 'UNLOCKED ✦' :
    safeState === 'wrong' ? 'WRONG CODE' : '';

  const statusCls =
    safeState === 'unlocked' ? 'safe-status status-ok' :
    safeState === 'wrong' ? 'safe-status status-error' : 'safe-status';

  return (
    <section className="safepage2">

      {/* NAV + TIMER */}
      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">TIME REMAINING</span>

          <div className="timerdiv">
            <span className={`timerdigits ${isWarning ? 'timerwarning' : ''}`}>
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning ? '#ff4444' : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div className="settings" onClick={openSettingsMenu} />
      </div>

      {/* QUESTION */}
      <div className="safe-top-ui">
        <h2 className="safe-question">WHAT WAS THE ROOM NUMBER?</h2>
        <p className={statusCls}>{statusText}</p>
      </div>

      {/* SAFE */}
      <div className="safe-wrapper">
        <div className={`safe-body ${safeState}`}>
          <div className={`safe-dial ${dialSpin ? 'spinning' : ''}`} />

          <div className="safe-display">
            {slots}
          </div>

          <div className={`safe-handle ${safeState === 'unlocked' ? 'open' : ''}`} />
        </div>

        <div className="safe-numpad">
          {[1,2,3,4,5,6,7,8,9].map((n) => (
            <button key={n} className="numpad-btn" onClick={() => handleDigit(String(n))}>
              {n}
            </button>
          ))}

          <button className="numpad-btn" onClick={() => handleDigit('0')}>
            0
          </button>

          <button className="numpad-btn clear-btn" onClick={handleClear}>
            CLEAR
          </button>
        </div>
      </div>

      {/* SETTINGS */}
      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

      {/* NEXT BUTTON */}
      {safeState === 'unlocked' && (
        <button className="nextbt" onClick={() => navigate('/task3')}>
          NEXT
        </button>
      )}

      {/* YOU LOST POPUP */}
      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem('room1_time');
          window.location.reload();
        }}
      />

    </section>
  );
};

export default Safepage2;